import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { StyledFAB } from "../../components/CustomStyles/CustomFAB";
import BootstrapInputSearch from "../../components/InputSearch/BootstrapInputSearch";
import IzyPagination from "../../components/IzyPagination";
import IzyTabsPanel from "../../components/IzyTabsPanel";
import { handleError } from "../../components/Utils/Utils";
import { GetTotalPage } from "../../Helpers/pagination";
import ProductService from "../../Services/ProductService/ProductService";
import NewsletterService from "../../Services/NewsletterService/NewsletterService";
import NewsletterStore from "../../Store/NewsletterStore";
import { productForm } from "./Container/NewForm";
import AddIcon from "@material-ui/icons/Add";
import moment from "moment-timezone";
import DateRangePickerFilter from "../../components/Filters/DateRangePicker";
import FileSaver from "file-saver";
import {
  Avatar,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  MenuItem,
  TableBody,
  TableContainer,
  TableHead,
  withWidth,
} from "@material-ui/core";
import {
  IZYTable,
  IZYTableRow,
  IZYTableCell,
} from "../../components/CustomStyles/CustomTable";
import Img from "../../components/Img";
import { formatCurrency } from "../../components/Utils/Currency";
import { Skeleton } from "@material-ui/lab";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import { usePrevState } from "../../Helpers/tools";
import { IzySwitch } from "../../components/CustomStyles/CustomSwitch";
import { useState } from "react";
import { useEffect } from "react";
import { useQuery } from "react-query";

const ProductListCard = (props) => {
  const {
    action,
    // data,
    data,
    onClickAvailability,
    onClickEdit,
    onClickDelete,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickEdit = () => {
    handleClose();
    onClickEdit(data);
  };

  const handleClickDeleteRestore = () => {
    handleClose();
    onClickDelete(data, data);
  };
  return (
    <IZYTableRow>
      {/* <IZYTableCell>{data.tenant.property.name || "-"}</IZYTableCell> */}
      <IZYTableCell>{data.email || ""}</IZYTableCell>
      <IZYTableCell>
        {moment(data.created_at).format("DD-MM-YYYY, HH:mm:ss")}
        {/* {data.created_at || "0"} */}
      </IZYTableCell>
      {/* <IZYTableCell>
        <button
          onClick={handleClickDeleteRestore}
          type="button"
          class="btn btn-outline-danger d-flex flex-row justify-content-center align-items-center "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            fill="currentColor"
            class="bi bi-trash"
            viewBox="0 0 15 15"
          >
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"></path>
            <path
              fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            ></path>
          </svg>
          <div style={{ marginLeft: ".5rem", fontSize: ".7rem" }}>Remove</div>
        </button>
      </IZYTableCell> */}
    </IZYTableRow>
  );
};

const ProductListCardLoading = () => {
  return (
    <IZYTableRow>
      <IZYTableCell>
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Avatar variant="rounded">
                <Skeleton
                  variant="rect"
                  animation="wave"
                  width={60}
                  height={60}
                />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={<Skeleton animation="wave" height={22} />} />
          </ListItem>
        </List>
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell></IZYTableCell>
    </IZYTableRow>
  );
};

const NewProduct = ({ width, params }) => {
  const [arrStatus, setArrStatus] = React.useState([
    {
      title: "Email",
      sub_title: 0,
      deleted: false,
      status: "available",
      total_data: 0,
      active: true,
    },
    // {
    //   title: "Dine",
    //   sub_title: 0,
    //   deleted: true,
    //   status: "available",
    //   total_data: 0,
    //   active: true,
    // },
  ]);

  const [newsletterState, newsletterActions] = NewsletterStore();
  const [perPage, setPerPage] = React.useState(10);
  const [totalPage, setTotalPage] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [statusActive, setStatusActive] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const prevPage = usePrevState(page);
  const prevSearch = usePrevState(search);
  const [triggerChangeShopDine, settriggerChangeShopDine] = useState(0);

  let tEnd = moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
  let tStart = moment(new Date()).format("YYYY-MM-DD") + " 00:00:00";
  const [dateRange, setDateRange] = React.useState({
    startDate: moment(tStart).tz("UTC").format(),
    endDate: moment(tEnd).tz("UTC").format(),
    key: "",
  });
  const [pageState, setPageState] = React.useState("");
  const [pageFilter, setPageFilter] = React.useState({
    num: 10,
    cursor:
      pageState?.headers && pageState?.headers["x-cursor"]
        ? pageState?.headers["x-cursor"]
        : "",
    keyword: search,
    date_start: dateRange.startDate,
    date_end: dateRange.endDate,
    progress:
      arrStatus[statusActive]?.status === "all"
        ? ""
        : arrStatus[statusActive]?.status,
  });
  // console.log();
  const toggleStatus = (index) => {
    setStatusActive(index);
    setPage(1);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  // console.log(arrStatus);
  const handleGetProductList = () => {
    if (triggerChangeShopDine === 0) {
      var query = {
        page: page || 1,
        perPage: perPage,
        // curated_type: 1,
        // deleted: arrStatus[statusActive].deleted === true ? "true" : "false",
        keyword: search,
      };
      newsletterActions.getList(query);
    } else {
      var query = {
        page: page || 1,
        perPage: perPage,
        // curated_type: 2,
        // deleted: arrStatus[statusActive].deleted === true ? "true" : "false",
        keyword: search,
      };
      newsletterActions.getList(query);
    }
  };
  useEffect(() => {
    handleGetResume(true);
  }, [triggerChangeShopDine]);

  const handleGetResume = (pararel) => {
    var params = {
      keyword: search,
      // type: triggerChangeShopDine ? 1 : 2,
    };

    NewsletterService.getResume(params)
      .then((response) => {
        let data = response.data;
        // console.log(response.data);
        // console.log("lonnn");
        const remapStatus = arrStatus.map((value, index) => {
          console.log(value);
          return {
            ...value,
            sub_title: data[value.status] || 0,
            total_data: data[value.status] || 0,
            // active: data[value.status] > 0 ? true : false,
          };
        });
        // console.log(data);
        // console.log(remapStatus);
        // console.log("^^^^^^^");

        setArrStatus(remapStatus);

        if (pararel) {
          console.log("parapel");
          handleGetProductList();
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  const handleChangePerPage = (perPage) => {
    setPerPage(perPage);
  };

  const handleActions = async (value) => {
    console.log("klik export");
    const res = await NewsletterService.getExportUser();
    console.log(res);
  };

  const handleDownloadTransactionOrder = () => {
    downloadTransactionDelivery.refetch();
  };

  const downloadTransactionDelivery = useQuery(
    ["downloadTransactionDelivery", pageFilter],
    () => {
      return NewsletterService.getExportUser(pageFilter).then(
        (res) => res.data
      );
    },
    {
      cacheTime: 0,
      enabled: false,
      retry: false,
      onError: (err) => {
        handleError(err);
      },
      onSuccess: (data) => {
        var temp =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          encodeURIComponent(data.content);
        var download = document.createElement("a");
        download.href = temp;
        download.download = data.file_name;
        document.body.appendChild(download);
        download.click();
        document.body.removeChild(download);
      },
    }
  );

  const handleDateChange = (val) => {
    let endDate = moment(val.endDate).format("YYYY-MM-DD") + " 23:59:59";
    let tStart = moment(val.startDate).tz("UTC").format();
    let tEnd = moment(endDate).tz("UTC").format();
    setDateRange({
      startDate: tStart,
      endDate: tEnd,
      key: val.key,
    });
    setPageFilter({
      ...pageFilter,
      cursor: "",
      date_start: tStart,
      date_end: tEnd,
    });
  };
  console.log(dateRange);
  const setAvailability = (data) => {
    confirm(
      !data.out_of_stock ? "Set Item Not Available" : "Set Available",
      !data.out_of_stock
        ? "Set this Item Not Available ?"
        : "Set this Item Available ?"
    ).then(async (onProcess) => {
      const params = [
        {
          op: "replace",
          path: "/out_of_stock",
          value: !data.out_of_stock,
        },
      ];
      let notif = `Successfully ${
        !data.out_of_stock ? "Set Item Not Available" : "Set Available"
      }`;
      await newsletterActions.patch(data.id, params, notif);
      handleGetProductList();
    });
  };

  const setStatusRemove = (data, value) => {
    confirm(
      `${!data.deleted_st ? "Remove Item" : "Restore Item"}`,
      `Are you sure to ${!data.deleted_st ? "remove" : "restore"} this item ?`
    ).then(async (onProcess) => {
      // console.log(value);
      // console.log("OOOOO");
      if (!data.deleted_st) {
        await newsletterActions.deletedCurrated(value.id);
      } else {
        // const params = [
        //   {
        //     op: "replace",
        //     path: "/deleted ",
        //     value: false,
        //   },
        // ];
        // let notif = `Successfully Restore Product`;
        // await newsletterActions.patch(data.id, params, notif);
      }

      handleGetResume(true);
    });
  };

  React.useEffect(() => {
    const getTotalPage = GetTotalPage(
      arrStatus[statusActive]["total_data"],
      perPage
    );
    setTotalPage(getTotalPage);
  }, [arrStatus, statusActive, perPage]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetResume();
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetProductList();
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      const newPage = prevPage > 1 ? 1 : "";
      if (prevPage) {
        setPage(newPage);

        if (prevPage === newPage) {
          handleGetProductList();
        }
      } else if (prevPage === "" && page === "") {
        setPage(1);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [search, perPage, statusActive]);

  useEffect(() => {
    handleGetProductList();
  }, []);
  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-12 px-0">
          <h3 className="font-16 font-bold mb-0">Newsletter</h3>
        </div>
        <div className="col-12 px-0">
          <div className="card rounded-8px border-0 mt-4">
            <div className="card-body border-0 px-4 pt-4 pb-0">
              <div className="w-100 d-flex justify-content-between align-items-center">
                <BootstrapInputSearch
                  placeholder="Search Email"
                  onChange={(e) => handleSearch(e)}
                />
                {/* <DateRangePickerFilter
                  onChange={(val) => handleDateChange(val)}
                  defaultDate={dateRange}
                  maxDate={new Date()}
                  label="Lihat Transaksi:"
                  iconPosition="right"
                  style={
                    width === "lg" || width === "xl" || width === "md"
                      ? { marginLeft: 12 }
                      : { marginLeft: 0, marginTop: 12 }
                  }
                /> */}
                {width !== "sm" && width !== "xs" && params.create && (
                  <button
                    type="button"
                    className="btn btn-blue"
                    // onClick={() => handleActions(null)}
                    onClick={() => handleDownloadTransactionOrder()}
                    disabled={downloadTransactionDelivery.isLoading}
                  >
                    Export Data Email
                  </button>
                )}
              </div>
              <p className="font-12 font-bold my-3">Status</p>
              <IzyTabsPanel
                tabs={arrStatus}
                tabActive={statusActive}
                onClick={(index) => {
                  settriggerChangeShopDine(index);
                  toggleStatus(index);
                }}
                // showSubTittle="1"
              />
            </div>
            <div className="card-body border-0 px-4 pt-0 pb-4">
              <TableContainer>
                <IZYTable>
                  <TableHead>
                    <IZYTableRow>
                      <IZYTableCell align="left" width="20%">
                        Email
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Created At
                      </IZYTableCell>

                      {/* <IZYTableCell align="left" width="5%"></IZYTableCell> */}
                    </IZYTableRow>
                  </TableHead>
                  <TableBody>
                    {!newsletterState.isLoading &&
                      newsletterState.data.length > 0 &&
                      newsletterState.data.map((value, key) => {
                        // console.log(value);
                        // console.log(">>>>>>>>>>>>>");
                        return (
                          <ProductListCard
                            key={key}
                            data={value}
                            onClickAvailability={(data) =>
                              setAvailability(data)
                            }
                            onClickEdit={(data) => {
                              handleActions(data);
                            }}
                            onClickDelete={(data) => {
                              setStatusRemove(data, value);
                            }}
                            action={params}
                          />
                        );
                      })}

                    {newsletterState.isLoading &&
                      Array.from(new Array(perPage)).map((value, key) => {
                        return <ProductListCardLoading key={key} />;
                      })}
                  </TableBody>
                </IZYTable>
              </TableContainer>
            </div>
          </div>
          <IzyPagination
            page={page || 1}
            perPage={perPage}
            total={arrStatus[statusActive]["total_data"] || 0}
            totalPage={totalPage}
            onChangePage={(page) => handleChangePage(page)}
            onChangePerPage={(perPage) => handleChangePerPage(perPage)}
          />
        </div>
      </div>
      {(width === "sm" || width === "xs") && params.create && (
        <StyledFAB color="primary" onClick={() => handleActions(null)}>
          <AddIcon />
        </StyledFAB>
      )}
    </BaseLayout>
  );
};

export default withWidth()(NewProduct);
